import React from "react";
import { isArray } from "lodash";
import { _getBaseUrl, _getTranslation, _truncateString } from "../utils/helper";

const CardLibrary = ({ data, ...props }) => {
  let countries = [];

  if (data.country.length > 0) {
    countries = data.country.map((item) => {
      return item.name;
    });
  }

  return (
    <div className="library-card">
      <a href={data.permalink} target="_blank" className="block mb-5 lg:mb-6 hover:opacity-60 transition-opacity" title={data.title}>
      <div className="flex gap-5 items-center">
        <img src={data.imageUrl} alt={data.imageAlt} className="w-[70px] xl:w-[110px] flex-shrink-0 border border-solid border-gray-200" />
        <div>
          <div className="library-card--title text-lg xl:text-xl">{_truncateString(data.title, 15)}</div>

          {isArray(data.organisations) && data.organisations.length > 0 && (
            <div className="library-card--organisation text-sm">{ data.organisations.join(', ') }</div>
          )}
          {data.year !== undefined && data.year !== '' && (
            <div className="library-card--year text-sm text-gray-400">{ data.year }</div>
          )}
          {countries.length > 0 && (
            <div className="library-card--country text-sm text-gray-400">{ countries.join(', ') }</div>
          )}
        </div>
      </div>
    </a>
  
  {isArray(data.topics) && data.topics.length > 0 && (
    <div className="library-card--tags flex flex-wrap justify-start gap-1">
      {data.topics.map((topic, i) => (
        <div className="library-card--tag click-library-card--tag" 
          onClick={() => props.onTagClick(topic.tid)}
          data-tid={topic.tid}>{topic.name}</div>
      ))}
    </div>
  )}
</div>
  )
};

export default CardLibrary;